import {IReactionOptions} from 'mobx/lib/api/autorun';
import {reaction as mobxReaction, IReactionDisposer, IReactionPublic} from 'mobx';
import {ILauncherServiceFactory} from './launcher-service-factory.interface';

export class LauncherServiceBase {
    constructor(private _serviceFactory: ILauncherServiceFactory) {
    }

    protected get services(): ILauncherServiceFactory {
        return this._serviceFactory;
    }

    private _reactions: IReactionDisposer[] = [];

    protected reaction<T>(expression: (r: IReactionPublic) => T, effect: (arg: T, r: IReactionPublic) => void, opts?: IReactionOptions): void {
        this._reactions.push(mobxReaction(expression, effect, opts));
    }

    dispose() {
        this._reactions.forEach(disposer => disposer());
    }
}